import { Col, Form, Input, Modal, Row, Button, Select } from "antd";
import React from "react";
import { useEffect } from "react";
import { PutServiceApi } from "../../api/listService";
import { useState } from "react";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";

const { Option } = Select;

const ModalEditProductService = ({
  isModalOpenEditProduct,
  handleOkEditProduct,
  setIsModalOpenEditProduct,
  fetchListDataService,
  dataInforProduct,
  idEditProduct,
  dataOptionCategory,
}) => {
  const [form] = Form.useForm();
  const [loadings, setLoadings] = useState(false);

  const handleCancelEditProduct = () => {
    setIsModalOpenEditProduct(false);
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    if (isModalOpenEditProduct) {
      form.setFieldsValue({
        category_id: dataInforProduct.categoryid,
        servicename: dataInforProduct.servicename,
      });
    }
  }, [isModalOpenEditProduct, dataInforProduct, form]);

  const onFinish = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    setLoadings(!loadings);
    data.append("id", idEditProduct);
    data.append("message", "update");
    data.append("categoryId", values.category_id);
    data.append("servicename", values.servicename);

    // currentDuAn
    PutServiceApi(data)
      .then((res) => {
        setLoadings(false);
        ToastSuccess.fire({
          icon: "success",
          title: "Cập nhật Product thành công",
        });
        fetchListDataService();
        handleCancelEditProduct();
      })
      .catch((error) => {
        ToastError.fire({
          icon: "error",
          title: error.data.message,
        });
      });
  };

  return (
    <Modal
      title="EDIT PRODUCT SERVICE"
      open={isModalOpenEditProduct}
      onOk={handleOkEditProduct}
      onCancel={handleCancelEditProduct}
      footer={false}
      width={800}
      className="headerTitleModal"
      forceRender={true}
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row>
          <Col span={11}>
            <Form.Item
              label="Category"
              name="category_id"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Category!",
                },
              ]}
            >
              <Select size="large" placeholder="Category">
                {dataOptionCategory.map((e) => (
                  <Option key={e.id} value={e.id}>
                    {e.category}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="Product/ Service"
              name="servicename"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Product/ Service!",
                },
              ]}
            >
              <Input size="large" placeholder="Product/ Service" />
            </Form.Item>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              className="btnSaveModel"
              type="success"
              htmlType="submit"
              loading={loadings}
              variant="contained"
            >
              Save
            </Button>
            <Button
              className="btnCancelModel"
              variant="outlined"
              onClick={handleCancelEditProduct}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalEditProductService;
